// <s-promo-popup> — opens the dialog named by data-target once per visitor after a short delay.
// Skips when the visitor already closed it, when data-end has passed, or in the theme editor.
class SPromoPopup extends HTMLElement {
  #timer = 0;
  #ac = null;

  connectedCallback() {
    const dialog = document.getElementById(this.dataset.target || "");
    if (!dialog || typeof dialog.showModal !== "function") return;
    if (this.hasAttribute("data-design-mode")) return;

    const end = Date.parse(this.dataset.end || "");
    if (!Number.isNaN(end) && Date.now() > end) return;

    const key = `kv-promo-${this.dataset.key || "default"}`;
    try {
      if (window.localStorage.getItem(key)) return;
    } catch (_error) {
      return;
    }

    this.#ac = new AbortController();
    dialog.addEventListener(
      "close",
      () => {
        try {
          window.localStorage.setItem(key, "1");
        } catch (_error) {
          // Storage can be blocked; the popup simply may show again next visit.
        }
      },
      { signal: this.#ac.signal },
    );

    const delay = Number(this.dataset.delay || 5) * 1000;
    this.#timer = window.setTimeout(() => {
      if (dialog.open || document.querySelector("dialog[open]")) return;
      dialog.showModal();
      // Failsafe: if the panel did not land on screen, close it so the page is never left dark and locked.
      window.setTimeout(() => {
        const rect = dialog.getBoundingClientRect();
        const offScreen = rect.height < 40 || rect.bottom <= 0 || rect.top >= window.innerHeight;
        if (dialog.open && offScreen) dialog.close();
      }, 600);
    }, delay);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#ac?.abort();
  }
}

if (!customElements.get("s-promo-popup")) {
  customElements.define("s-promo-popup", SPromoPopup);
}
